<template>
  <div class="row">
    <div class="panel bg-transparent columns large-6 medium-12 large-centered">
      <p v-html="t('forms.are_you_preregistered.IC_0126')"/>
      <div class="text-center">
        <label>
          <span v-html="t('forms.are_you_preregistered.IC_0127')"/>
          <input
            v-model="regCode"
            class="no-margin"
            type="text"
            maxlength="6"
            @keyup.enter="checkRegistrationCode">
          <small
            v-if="regCodeError"
            class="error">Invalid entry, Activation Code should be 6 characters</small>
        </label>
        <div class="row">
          <div class="columns large-3">
            <button
              class="tiny radius marginTop expand"
              @click="checkRegistrationCode"
              v-text="t('forms.are_you_preregistered.IC_0128')"/>
          </div>
          <div class="columns large-3">
            <button
              @click="openGuide"
              class="tiny radius marginTop expand"
              v-text="t('register.user_guide')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $      from 'jquery';
import _      from 'lodash';
import toastr from 'toastr';

export default {
  data() {
    return {
      regCode: '',
      regCodeError: false,
    };
  },

  watch: {
    regCode(val) {
      if (_.size(val) > 0 && _.size(val) !== 6) {
        this.regCodeError = true;
      }

      if (_.size(val) === 6) {
        this.regCodeError = false;
      }
    },
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    checkRegistrationCode() {
      if (_.size(this.regCode) !== 6) {
        return false;
      }

      $.post('/register/activation-code', {
        code: this.regCode,
      }, (data) => {
        if (data === 'gePass') {
          this.$emit('ge-contractor');
          this.$emit('stage-change', 1);
        } else if (data === 'pass') {
          this.$emit('stage-change', 1);
        } else if (data === 'not found') {
          toastr.error('Code not found.');
        } else if (data === 'used') {
          toastr.error('This code has already been used.');
        }
      });

      return false;
    },
  },
};
</script>
<style scoped>
.marginTop {
  margin-top: 20px;
  margin-bottom: 0;
}
a {

}
</style>
